import { render } from "./CampaignName.vue?vue&type=template&id=110c2358"
import script from "./CampaignName.vue?vue&type=script&lang=js"
export * from "./CampaignName.vue?vue&type=script&lang=js"

import "./CampaignName.vue?vue&type=style&index=0&id=110c2358&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__